var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 185.863281 50.109375 L 185.863281 50.667969 L 67.675781 120.230469 L 68.160156 120.511719 L 69.308594 257.644531 L 69.789062 257.371094 L 189.128906 324.9375 L 189.128906 324.386719 L 307.316406 254.816406 L 306.835938 254.539062 L 306.253906 184.949219 L 189.359375 255.949219 L 129.171875 223.347656 L 127.308594 154.921875 C 157.667969 137.230469 195.867188 112.867188 241.898438 81.835938 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteShape);
export default __webpack_public_path__ + "static/media/WhiteShape.9374eb929d0123b30fc5036b4c70bc8e.svg";
export { ForwardRef as ReactComponent };